<template>
  <div class="introducing-form">
    <VForm :name="name" :initialValues="initialValues" :fields="fields"></VForm>
    <div class="email-wrapper">
      <div class="title">Email</div>
      <div v-show="email" class="email">{{ email }}</div>
    </div>
    <div class="footer">
      <div class="btn-wrapper">
        <VButton
          label="Continue"
          :disabled="!_isFormValid || isLoading"
          @click="onBtnClick"
        ></VButton>
      </div>
      <div class="additional-text-wrapper">
        <p>
          By creating an Inkit account, you agree to our
          <VLink
            type="primary"
            href="https://www.inkit.com/legal/terms-of-service/"
            blank
            label="Terms of services"
          ></VLink>
          and
          <VLink
            type="primary"
            href="https://www.inkit.com/legal/privacy-policy/"
            blank
            label="Privacy policy"
          ></VLink>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueTypes from "vue-types";

import { mapActions, mapGetters } from "vuex";

import VForm from "@/components/VForm";
import { required, maxLength, maxLengthSplit } from "@/utils/validations";
import VButton from "@/components/VButton";
import VLink from "@/components/VLink";

//mixins
import withFormUtils from "@/mixins/withFormUtils";
import withToasted from "@/mixins/withToasted";
import withDialogWindowsSequence from "@/mixins/withDialogWindowsSequence";

export default Vue.component("SignUpIntroducingForm", {
  components: { VForm, VButton, VLink },

  data() {
    return {
      name: "signUpIntroducing",
      id: null,
      email: null,
      initialValues: {},
      fields: [
        {
          name: "name",
          elementType: "text",
          label: "Account Name",
          placeholder: "Enter Account Name",
          isRequired: true,
          validate: [required, maxLength(40)]
        },

        {
          name: "first_name",
          elementType: "text",
          label: "First Name",
          placeholder: "Enter First Name",
          isRequired: true,
          validate: [required, this.maxLengthFirstLastNames.bind(this)]
        },

        {
          name: "last_name",
          elementType: "text",
          label: "Last Name",
          placeholder: "Enter Last Name",
          isRequired: true,
          validate: [required, this.maxLengthFirstLastNames.bind(this)]
        }
      ]
    };
  },

  mixins: [withFormUtils, withToasted, withDialogWindowsSequence],

  computed: {
    _isFormValid() {
      return this.isFormValid(this.name);
    },
    ...mapGetters("account", ["isLoading", "identity"])
  },

  methods: {
    onBtnClick() {
      this.validateForm(this.name);
      const {
        identity: { account }
      } = this;
      const { name, first_name, last_name } = this.formValues;

      if (
        account &&
        account.name === name &&
        account.first_name === first_name &&
        account.last_name === last_name
      ) {
        this.nextSequencePage();
      } else if (this._isFormValid) {
        this.updateAccount({
          patch: true,
          id: this.id,
          values: { name, first_name, last_name },
          cb: () => {
            this.updateUser({
              values: {
                first_name,
                last_name
              },
              onSuccess: () => {
                localStorage.setItem(
                  this.name,
                  JSON.stringify(this.formValues)
                );
                this.nextSequencePage();
              },

              onError: () => {
                this.errorToast(
                  "Failed to save first and last name. Please, try again later."
                );
              }
            });
          },
          onError: e => {
            this.errorToast(e);
          }
        });
      }
    },

    //TODO make inputs errors sync
    maxLengthFirstLastNames() {
      const { first_name, last_name } = this.formValues;
      if (first_name && last_name) {
        const firstNameField = this.getField("first_name");
        const lastNameField = this.getField("last_name");
        if (firstNameField.meta.blurred && lastNameField.meta.blurred) {
          return maxLengthSplit(40)(first_name, last_name);
        }
      }
    },

    ...mapActions("account", ["updateAccount", "updateUser"])
  },

  created() {
    const { user, account } = this.identity;

    this.id = account.id;
    this.email = user.email;

    if (account && account.name) {
      this.initialValues = {
        name: account.name,
        first_name: user.first_name,
        last_name: user.last_name
      };
    }
  }
});
</script>

<style lang="scss" scoped>
.introducing-form {
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
}

.email-wrapper {
  font-size: 15px;

  .title {
    color: $main-text-color;
    font-family: "Lato-Bold", Arial, sans-serif;
    padding: 0 0 14px 8px;
  }

  .email {
    color: $secondary-text-color;
  }
}

.additional-text-wrapper {
  font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
  color: $main-text-color;
  font-size: 14px;
  line-height: 1.5;
  margin-top: 15px;

  a {
    font-size: 14px;
    font-family: Lato-Regular, Arial, Helvetica, "sans-serif";
  }

  p {
    text-align: center;
  }
}
</style>
